module.exports = __webpack_public_path__ + "static/media/homeClean.7a55ecb1.svg";